// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1VADR","header":"PatientQuestionnaire_header__1BiAx","info":"PatientQuestionnaire_info__1C-bH"};